import React, { useState, useEffect, Fragment } from "react";
import "./index.scss";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Host from "../../Components/Host";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import Button from "@mui/joy/Button";
import { useSelector, useDispatch } from "react-redux";
import PhoneInput, {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  isValidPhoneNumber,
  isPossiblePhoneNumber,
} from "react-phone-number-input";
import ReCAPTCHA from "react-google-recaptcha";
import { useCreateInquiriesMutation } from "../../services/inquiries";
import { addToInquiry } from "../../Reducers/authReducer";
import HelmetComponent from "../../Components/HelmetComponent";
import { Box } from "@mui/material";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import LanguageIcon from "@mui/icons-material/Language";
import { getMetaByCountry } from "../../metaConfig";
function ContactUs() {
  const { userId, userToken, userEmail, userName, isMember, mediaLang, countryCode, languageCode, isInquiry } =
    useSelector((state) => state.auth);
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const [createinquiry, createresult] = useCreateInquiriesMutation();

  const [getPhone, setPhone] = useState("");
  const [getPhoneError, setPhoneError] = useState(false);
  const [isAlready, setAlready] = useState(false);
  const recaptchaRef = React.useRef();

  async function createInquiryFrom(data) {
    const token = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();
    if (isValidPhoneNumber(getPhone)) {
      if (isInquiry) {
        setAlready(true);
      } else {
        createinquiry({
          name: data.name,
          email: data.email,
          message: data.message,
          phone: getPhone,
          language: languageCode,
          country: countryCode,
          captcha_token: token,
          domain: Host?.domain,
          domainEmail: Host?.email,
        });
      }
    } else {
      setPhoneError(true);
    }
  }

  useEffect(() => {
    if (createresult?.isSuccess) {
      dispatch(
        addToInquiry({
          isInquiry: true,
        })
      );
    }
  }, [createresult]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  function checkExist() {
    if (createresult?.isSuccess) {
      return true;
    } else if (isAlready) {
      return true;
    } else {
      return false;
    }
  }

  function googlMap() {
    return (
      <>
        {/* <iframe src={gtmId} width="100%" height="350" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
      </>
    );
  }

  const [isMetaTitle, setMetaTitle] = useState("");
  useEffect(() => {
    const { title } = getMetaByCountry(countryCode);
    setMetaTitle(title);
  }, [countryCode]);

  return (
    <>
      <HelmetComponent title={"Contact Us"} metaTitle={isMetaTitle} />
      <div className="statisc-page">
        <div className="container static-container">
          <div className="row static-row">
            <div className="col-md-10">
              <br /> <br />
              <div className="row" style={{ justifyContent: "center" }}>
                <div className="col-md-6">
                  <h1 style={{ marginBottom: "20px", fontWeight: 400, fontSize: "1.2rem" }}>Contact Us</h1>
                  <p>We’re here to help.</p>
                  <p>
                    For questions about orders, delivery, payments, returns, refunds, warranty support, product
                    information, or general assistance, please contact our customer support team.
                  </p>
                  <br />
                  <h1 style={{ marginBottom: "20px", fontWeight: 400, fontSize: "1.2rem" }}>Customer Support</h1>
                  <p style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Box
                      sx={{
                        width: 36,
                        height: 36,
                        borderRadius: "50%",
                        background: "#fff7f2",
                        border: "1px solid #ffe1d2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 10px 28px rgba(255, 113, 68, 0.14)",
                      }}
                    >
                      <MailOutlineIcon
                        sx={{
                          fontSize: 18,
                          color: "#ff7043",
                        }}
                      />
                    </Box>
                    {Host?.email}
                  </p>
                  <p style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Box
                      sx={{
                        width: 36,
                        height: 36,
                        borderRadius: "50%",
                        background: "#fff7f2",
                        border: "1px solid #ffe1d2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 10px 28px rgba(255, 113, 68, 0.14)",
                      }}
                    >
                      <PhoneIcon
                        sx={{
                          fontSize: 18,
                          color: "#ff7043",
                        }}
                      />
                    </Box>
                    {Host?.phone}
                  </p>
                  <p style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Box
                      sx={{
                        borderRadius: "10px",
                        background: "#fff7f2",
                        border: "1px solid #ffe1d2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "left",
                        boxShadow: "0 10px 28px rgba(255, 113, 68, 0.14)",
                        padding: "15px",
                        gap: "10px",
                      }}
                    >
                      <AccessTimeOutlinedIcon
                        sx={{
                          fontSize: 28,
                          color: "#ff7043",
                        }}
                      />
                      <div>
                        <div style={{ fontWeight: 700 }}>Contact Support</div>
                        <div>{Host?.customerSupport}</div>
                      </div>
                    </Box>
                  </p>
                  <br />
                  {/* {googlMap()} */}

                  <h1 style={{ marginBottom: "20px", fontWeight: 400, fontSize: "1.2rem" }}>Business Information</h1>

                  <svg width="320" height="56" viewBox="0 0 320 56" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0" y="4" width="36" height="44" rx="4" fill="#fff" stroke="#1a56db" stroke-width="1.5" />
                    <polygon points="24,4 36,4 36,16 24,16" fill="#dbeafe" />
                    <polygon points="24,4 36,16 24,16" fill="#1a56db" opacity="0.3" />
                    <rect x="5" y="20" width="26" height="3" rx="1.5" fill="#9ca3af" />
                    <rect x="5" y="26" width="20" height="3" rx="1.5" fill="#9ca3af" />
                    <circle cx="10" cy="39" r="6" fill="none" stroke="#f59e0b" stroke-width="1.5" />
                    <polygon
                      points="10,35 11,38 14,38 11.5,39.8 12.5,42.8 10,41 7.5,42.8 8.5,39.8 6,38 9,38"
                      fill="#f59e0b"
                    />
                    <circle cx="30" cy="10" r="6" fill="#16a34a" />
                    <polyline
                      points="27,10 29.5,12.5 33.5,7"
                      fill="none"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <text x="46" y="15" font-family="sans-serif" font-size="13" font-weight="600" fill="#111827">
                      Trade Name: {Host?.domainName2}
                    </text>
                    <text x="46" y="32" font-family="sans-serif" font-size="13" font-weight="600" fill="#111827">
                      Trade License: {Host?.companyName}
                    </text>
                    <text x="46" y="50" font-family="sans-serif" font-size="12" fill="#6b7280">
                      License Number: {Host?.licenseNumber}
                    </text>
                  </svg>
                  <div className="cp-phone-section" style={{ display: "flex", padding: 0 }}>
                    <div style={{ margin: "10px 0px", fontSize: "1rem" }}>
                      <div style={{ color: "#363535", fontWeight: 400, fontSize: "1rem" }}></div>
                      <div style={{ fontSize: "1rem" }}>
                        <p style={{ display: "flex", gap: "10px" }}>
                          <Box
                            sx={{
                              width: 36,
                              height: 36,
                              borderRadius: "50%",
                              background: "#fff7f2",
                              border: "1px solid #ffe1d2",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: "0 10px 28px rgba(255, 113, 68, 0.14)",
                            }}
                          >
                            <FmdGoodOutlinedIcon
                              sx={{
                                fontSize: 18,
                                color: "#ff7043",
                              }}
                            />
                          </Box>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: Host?.address,
                            }}
                          ></div>
                        </p>
                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                          <Box
                            sx={{
                              width: 36,
                              height: 36,
                              borderRadius: "50%",
                              background: "#fff7f2",
                              border: "1px solid #ffe1d2",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: "0 10px 28px rgba(255, 113, 68, 0.14)",
                            }}
                          >
                            <LanguageIcon
                              sx={{
                                fontSize: 18,
                                color: "#ff7043",
                              }}
                            />
                          </Box>
                          <span>{window.location.hostname}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <h1 style={{ marginBottom: "20px", fontWeight: 400, fontSize: "1.2rem" }}>Before Contacting Us</h1>
                  <div className="cp-phone-section" style={{ display: "flex", padding: 0 }}>
                    <div style={{ margin: "10px 0px", fontSize: "1rem" }}>
                      <div style={{ color: "#363535", fontWeight: 400, fontSize: "1rem" }}></div>
                      <p>
                        For faster assistance, please include your order number, registered email address, phone number,
                        and a short description of your request.
                      </p>
                      <p>
                        For damaged, defective, incorrect, or not-as-described items, please include clear photos or
                        video of the product and packaging where applicable.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div
                    className="static-container-card"
                    style={{
                      textAlign: "left",
                      padding: "20px",
                      background: "#fcfcfc",
                      border: "1px solid #eee",
                      borderRadius: "7px",
                    }}
                  >
                    <h4 style={{ padding: "20px 0px 20px 0px" }}>{t("Send us your query")}</h4>
                    {checkExist() ? (
                      <>
                        {!createresult?.isSuccess && isAlready ? (
                          <div style={{ textAlign: "center" }} className="alert alert-danger">
                            Your inquiry already has been received. We will get back to you shortly.
                          </div>
                        ) : (
                          <div style={{ textAlign: "center" }} className="alert alert-success">
                            Your inquiry has been received. We will get back to you shortly.
                          </div>
                        )}
                      </>
                    ) : (
                      <form onSubmit={handleSubmit(createInquiryFrom)}>
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          size="invisible"
                          sitekey="6LfD62EnAAAAAJ83k0BznR8m_cXInxBFjtTokspL"
                        />
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label style={{ fontSize: "14px" }}>{t("name")} </label>
                              <input
                                type="text"
                                className="form-control"
                                id="name"
                                aria-invalid={errors.name ? "true" : "false"}
                                {...register("name", { required: true })}
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <label style={{ fontSize: "14px" }}>{t("email")} </label>
                              <input
                                type="text"
                                className="form-control"
                                id="email"
                                aria-invalid={errors.email ? "true" : "false"}
                                {...register("email", { required: true })}
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <label style={{ fontSize: "14px" }}>{t("phone")} </label>
                              <PhoneInput
                                international
                                countryCallingCodeEditable={false}
                                defaultCountry={countryCode}
                                value={getPhone}
                                onChange={setPhone}
                              />
                              {getPhoneError && (
                                <>
                                  {getPhone && isValidPhoneNumber(getPhone) ? (
                                    ""
                                  ) : (
                                    <div>
                                      <small style={{ color: "tomato" }}>{"Invalid phone number"}</small>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <label style={{ fontSize: "14px" }}>{t("message")} </label>
                              <textarea
                                type="text"
                                className="form-control"
                                id="message"
                                aria-invalid={errors.message ? "true" : "false"}
                                {...register("message", { required: true })}
                              ></textarea>
                            </div>
                          </div>

                          <div className="col-md-12 Header-signin-button">
                            <div className="form-group">
                              <Button
                                disabled={createresult.isLoading}
                                style={{
                                  background: Host?.bgColor,
                                  color: Host?.buttonColor,
                                  width: "100%",
                                  height: "45px",
                                }}
                                type="submit"
                              >
                                {createresult.isLoading ? t("loading") : t("submit")}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
    </>
  );
}

export default ContactUs;
